import { Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function TasksHeader() {
    const { taskCount } = useBoundContext()
    return <Typography variant="subtitle1" p={2} data-cy="task-count-header">{`Tasks (${taskCount})`}</Typography>
}
